import * as React from "react";
import * as Immutable from "immutable";
import { useState, useEffect, useContext, useMemo } from "react";
import { useFormikContext } from "formik";
import { OKTA_TYPE_KEY } from "authentication/components/oidc/constants";
import { loadMatchingGroups } from "authentication/api/groupSync";
import prepareOktaLoadGroupsPayload from "authentication/logic/okta/prepareOktaLoadGroupsPayload";
import { OidcBackendMetaContext } from "authentication/components/oidc/config/components/OidcBackendMetaProvider";
import OktaMatchingGroupsContext from "./OktaMatchingGroupsContext";
const OktaMatchingGroupsProvider = ({ children, prepareSubmitPayload }) => {
  const { backendId, backendGroupSyncIsActive } = useContext(OidcBackendMetaContext);
  const { values: currentFormValues } = useFormikContext();
  const [contextValue, setContextValue] = useState({ result: void 0, finishedLoading: true });
  const oktaMatchingGroupsContextValue = useMemo(() => ({ ...contextValue, setContextValue }), [contextValue]);
  useEffect(() => {
    if (backendId && backendGroupSyncIsActive) {
      setContextValue({ finishedLoading: false, result: void 0 });
      const payload = prepareOktaLoadGroupsPayload(prepareSubmitPayload, currentFormValues, backendId, OKTA_TYPE_KEY);
      loadMatchingGroups(payload).then((result) => {
        setContextValue({ finishedLoading: true, result });
      }).catch((error) => {
        setContextValue({ finishedLoading: true, result: { errors: Immutable.List([error]) } });
      });
    }
  }, []);
  return /* @__PURE__ */ React.createElement(OktaMatchingGroupsContext.Provider, { value: oktaMatchingGroupsContextValue }, children);
};
export { OktaMatchingGroupsContext };
export default OktaMatchingGroupsProvider;
